module.exports = __webpack_public_path__ + "img/platzi.b375b86f.png";